export default {
	"exchange.inTheProduct": "商品中的",
	"exchange.HasBeenActivatedInOrderToAvoidMissingTheExperienceTimePleaseLogInToTheCallMiniProgramOrAppAsSoonAsPossibleToExperience": "已被激活，为避免错过体验时间，请尽快登录【叫叫】小程序或 App 进行体验。",
	"exchange.ViewOrderDetails": "查看订单详情",
	"exchange.LongPressToIdentifyTheQRCode": "长按识别二维码",
	"exchange.EnterTheCallMiniProgram": "进入叫叫小程序"
}